module.exports = __webpack_public_path__ + "img/thumbfield5.6450f72f.png";